import React from "react";
import "./GPTeam.css";

const teamMembers = [
  { name: "श्री. कैलास डोमाजी ठाकरे ", designation: " ग्रामपंचायत सदस्य मानोरा  ", phone: "+91 8999028296", imageUrl: "/images/kailash.jpeg" },
  { name: "श्री. मिथुन जीवन माटे", designation: " ग्रामपंचायत सदस्य मानोरा ", phone: "+91 9270096164", imageUrl: "/images/mithun.jpeg" },
  { name: "सौ.शिल्पा सोमेश्वर गुडधे", designation: " ग्रामपंचायत सदस्या मानोरा ", phone: "+91 8788565341", imageUrl: "/images/shilpa.jpeg" },
  { name: "सौ. सपना दिनेश लुटे", designation: " ग्रामपंचायत सदस्या मानोरा ", phone: "+91 9763675857", imageUrl: "/images/sapna.jpeg" },
  { name: "सौ.वनमाला संतोष फुलझेले", designation: "  ग्रामपंचायत सदस्या मानोरा  ", phone: "+91 9021130483", imageUrl: "/images/vanmala.jpeg" },
  { name: "सौ.लेणेश्वरी मित्रजित मेश्राम", designation: " ग्रामपंचायत सदस्या मानोरा ", phone: "+91 9370730457", imageUrl: "/images/lene.jpeg" },
 

];

const karmachariMembers = [
  { name: " --  ", designation: "सफाई  कर्मचारी", imageUrl: "/images/men.png" },
  { name: "--  ", designation: "लिपिक  कर्मचारी", imageUrl: "/images/men.png" },
  { name: "--", designation: "ग्रामपंचायत कर्मचारी", imageUrl: "/images/men.png" },
  { name: "--", designation: "संगणक परिचालक", imageUrl: "/images/men.png" },
  { name: "--", designation: "पानी पुरवठा  कर्मचारी", imageUrl: "/images/men.png" },
];


const GPTeam = () => {
  return (
    <div className="gp-container">

      {/* HEADER */}
      <div className="gp-header">
        <img
          src="/images/sj1.jpg"
          alt="Emblem"
          className="gp-logo"
        />
        <h1 className="gp-title">ग्रामपंचायत कार्यकारी समिती</h1>
        <p className="gp-subtitle">
          The Governing Body — Committed to Community Service
        </p>
      </div>

      {/* TEAM CARDS */}
      <div className="gp-grid">
        {teamMembers.map((member, index) => (
          <div key={index} className="gp-card">
            <img
              src={member.imageUrl}
              alt={member.name}
              className="gp-photo"
            />
            <h2 className="gp-name">{member.name}</h2>
            <p className="gp-designation">{member.designation}</p>
            <p className="gp-phone">📞 {member.phone}</p>
          </div>
        ))}
      </div>
      {/* KARMACHARI SECTION */}
      <h2 className="gp-section-title">कर्मचारी</h2>

      <div className="gp-grid">
        {karmachariMembers.map((member, index) => (
          <div key={index} className="gp-card">
            <img
              src={member.imageUrl}
              alt={member.name}
              className="gp-photo"
            />
            <h2 className="gp-name">{member.name}</h2>
            <p className="gp-designation">{member.designation}</p>
          </div>
        ))}
      </div>

      {/* FOOTER */}
      <div className="gp-footer">
        © 2025 Gram Panchayat — All Rights Reserved.
      </div>
    </div>
  );
};

export default GPTeam;
